import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, CalendarClock, Package, ChevronRight, TrendingUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobilePlanningPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/items`).then(r => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  const fgItems = items.filter(i => i.item_type === 'finished_good' || !i.item_type);

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Planning</div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Items</div><div className="mobile-kpi-value">{fgItems.length}</div></div>
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Categories</div><div className="mobile-kpi-value">{[...new Set(fgItems.map(i => i.category).filter(Boolean))].length}</div></div>
      </div>

      <div className="mobile-section-header"><span className="mobile-section-title">Quick Links</span></div>
      <div className="mobile-menu-list" style={{ marginBottom: 16 }}>
        <button className="mobile-menu-item" onClick={() => navigate('/mobile/schedule')}>
          <div className="mobile-menu-item-icon" style={{ background: '#007aff' }}><CalendarClock size={16} /></div>
          <div className="mobile-menu-item-content"><div className="mobile-menu-item-title">Production Schedule</div><div className="mobile-menu-item-subtitle">View upcoming work orders</div></div>
          <ChevronRight size={16} className="mobile-menu-item-chevron" />
        </button>
        <button className="mobile-menu-item" onClick={() => navigate('/mobile/production')}>
          <div className="mobile-menu-item-icon" style={{ background: '#34c759' }}><TrendingUp size={16} /></div>
          <div className="mobile-menu-item-content"><div className="mobile-menu-item-title">Active Production</div><div className="mobile-menu-item-subtitle">Monitor running work orders</div></div>
          <ChevronRight size={16} className="mobile-menu-item-chevron" />
        </button>
      </div>

      <div className="mobile-section-header"><span className="mobile-section-title">Finished Goods</span></div>
      <div className="mobile-menu-list">
        {fgItems.map(item => (
          <button key={item.item_id} className="mobile-menu-item" onClick={() => navigate(`/mobile/items/${item.item_id}`)}>
            <div className="mobile-menu-item-icon" style={{ background: '#ff9500' }}><Package size={16} /></div>
            <div className="mobile-menu-item-content">
              <div className="mobile-menu-item-title">{item.name}</div>
              <div className="mobile-menu-item-subtitle">{item.sku || 'N/A'} · On hand: {item.on_hand || 0}</div>
            </div>
            <ChevronRight size={16} className="mobile-menu-item-chevron" />
          </button>
        ))}
      </div>
    </div>
  );
}
